export default __webpack_public_path__ + "static/media/PodcastOne_Logo_mono.bbb7d101.svg";